import './style.scss';

import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Tooltip } from '@mui/material';
import { FC, ReactElement, useContext } from 'react';

import { WebSocketContext, STATES } from '../../providers/websocket-context/websocket-provider';

const STATE_CLASS_DEFAULT = 'connection-data-status-connecting';
const MESSAGE_DEFAULT = 'Connecting';
const TOOLTIP_DEFAULT = 'Establishing connection to receive live data';

export const ConnectionStatus: FC = (): ReactElement => {
  const { statusEnum, isReconnection } = useContext(WebSocketContext);

  const dataStatus = {
    [STATES.CONNECTING as number]: {
      message: 'Connecting',
      class: 'connection-data-status-connecting',
      tip: 'Establishing connection to receive live data',
    },
    [STATES.OPEN as number]: {
      message: !isReconnection ? 'Stable connection' : 'Reconnecting...',
      class: !isReconnection
        ? 'connection-data-status-success'
        : 'connection-data-status-connecting',
      tip: !isReconnection ? 'Receiving live data' : 'Re-establishing connection',
    },
    [STATES.CLOSED as number]: {
      message: 'Disconnected',
      class: 'connection-data-status-closed',
      tip: 'Please check your internet connection to receive live data',
    },
    [STATES.CLOSING as number]: {
      message: 'Closing connection',
      class: 'connection-data-status-connecting',
      tip: 'Please check your internet connection to receive live data',
    },
  }[statusEnum];

  return (
    <Tooltip title={dataStatus?.tip || TOOLTIP_DEFAULT} arrow>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className="connection-data"
        rowSpacing={1}
        columnSpacing={1}
      >
        <Grid item className={dataStatus?.class || STATE_CLASS_DEFAULT}>
          <FontAwesomeIcon icon={faCircle} className="connection-data-status-icon" />{' '}
          {dataStatus?.message || MESSAGE_DEFAULT}
        </Grid>
      </Grid>
    </Tooltip>
  );
};

export default ConnectionStatus;
